'use strict';

exports.__esModule = true;

var _react = require('react');

exports.default = _react.PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/types/controlPosition.js
// module id = 44
// module chunks = 0